import { gql } from 'graphql-request'

export const M_CREATE_TRIAL_SUBSCRIPTION = gql`
  mutation CreateTrialSubscription($paymentMethodId: String!, $annual: Boolean = true, $referralCode: String, $couponCode: String, $checkoutTosAcceptedAt: String, $tier: String) {
    createTrialSubscription(paymentMethodId: $paymentMethodId, annual: $annual, referralCode: $referralCode, couponCode: $couponCode, checkoutTosAcceptedAt: $checkoutTosAcceptedAt, tier: $tier) {
      ... on TrialSubscriptionSuccess {
        success
        trialEndsAt
        planName
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`

export const M_CREATE_WEEKLY_SUBSCRIPTION = gql`
  mutation CreateWeeklySubscription($paymentMethodId: String!, $referralCode: String, $checkoutTosAcceptedAt: String) {
    createWeeklySubscription(paymentMethodId: $paymentMethodId, referralCode: $referralCode, checkoutTosAcceptedAt: $checkoutTosAcceptedAt) {
      ... on TrialSubscriptionSuccess {
        success
        trialEndsAt
        planName
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`
